// We purposely don't import shared JavaScript here because the shared
// folder is only meant between users and admin namespaces.
// We want the landing as light as possible.
// import "../shared/shared";
//
// Turbo (and the ActionCable consumer it pulls in)
// is loaded here so the public Restaurant Audit
// page at `/grade/:slug` (which lives on this
// layout) can subscribe to the audit's Turbo
// Stream channel and animate the live progress UI
// from server broadcasts (see `RestaurantAudits::
// RunStepJob#perform`).
import "@hotwired/turbo-rails";
import { Turbo } from "@hotwired/turbo-rails";
import ahoy from "ahoy.js";
import "../controllers/landing";
import "../shared/posthog";

// Expose GSAP on `window` in dev only so we can poke
// at tweens from the browser console / chrome-devtools
// MCP `evaluate_script` calls (e.g. wrapping
// `gsap.fromTo` to count audit-reveal play() calls
// during a stage walk). Production omits this so we
// don't ship a global. `import.meta.env.DEV` is the
// Vite dev-mode flag and is statically replaced at
// build time, so the import + assignment get tree-
// shaken from the production bundle.
if (import.meta.env.DEV) {
  import("gsap").then(({ gsap }) => {
    window.gsap = gsap;
  });
}

// The Restaurant Audit page broadcasts targeted
// dataset updates via the `set_dataset_attributes`
// custom Turbo Stream action (see
// `app/models/concerns/turbo_broadcastable.rb`
// and the canonical example in
// `app/javascript/shared/shared.js`). This entrypoint
// deliberately doesn't pull in `shared.js`, so the
// action is registered inline here. Without this,
// every broadcast lands as `unknown action` and the
// audit-stage controller never advances.
Turbo.StreamActions.set_dataset_attributes = function () {
  const target = this.getAttribute("target");
  const attributes = JSON.parse(
    this.getAttribute("attributes")
  );
  const element = document.querySelector(target);
  if (!element) return;
  Object.entries(attributes).forEach(([key, value]) => {
    element.dataset[key] = value;
  });
};

// NOTE: this entrypoint deliberately does NOT install
// the morphdom + walk-and-reconnect Stimulus hooks
// that `users.js` runs. That hook was inherited here
// when the audit page used `broadcast_refresh_later`,
// because the live progress UI needed Leaflet to
// survive page-level morphs.
//
// CAL-253 replaced refresh broadcasts with targeted
// `set_dataset_attributes` actions and `update`
// actions on hidden pending slots, neither of which
// fires `turbo:before-render`. So the hook never
// runs on legitimate audit traffic. What it DID do
// is fire on every other Turbo Drive transition on
// the landing surface and, more importantly, mass-
// reconnect every Stimulus controller on the page,
// which made `audit-reveal` controllers re-mount
// and replay their entrance every time the dom was
// touched, producing the "skeleton → revealed →
// skeleton again → animate again" symptom on the
// live audit page.
//
// `admin.js` lives without this hook fine. The
// landing surface should too.

// Used also in shared.js
//
// These are set on our routes.rb file. We are manually setting the engine's
// routes to "/cal-t" so that lists such as EasyPrivacy don't block us.
// https://github.com/easylist/easylist/blob/master/easyprivacy/easyprivacy_general.txt#L166-L167
ahoy.configure({
  visitsUrl: "/cal-t/visits",
  eventsUrl: "/cal-t/events",
});
